import { Injectable } from '@angular/core';
import {ActiveToast, ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastr: ToastrService) { }

  /**
   * This method is used to show success toast notification
   * @param message
   */
  showSuccess(message: any) {
    const toastRef = this.toastr.success(message, '');
    this.clearToaster(toastRef);
  }

  /**
   * This method is used to show error toast notification
   * @param message
   */
  showError(message: any) {
    const toastRef = this.toastr.error(message, '');
    this.clearToaster(toastRef);
  }

  /**
   * Clears the toaster after it has been hidden
   */
  private clearToaster(toastRef: ActiveToast<any>) {
    if (!toastRef || !toastRef.toastId) return;
    setTimeout(() => {
      this.toastr.clear(toastRef.toastId);
    }, 3500); // Make sure this delay is slightly longer than your `timeOut`
  }

  showInfo(message: any) {
    const toastRef = this.toastr.info(message, '');
    this.clearToaster(toastRef);
  }
}
